import type { ButtonSelectionType } from '../UIElements/ButtonSelectionType'
import type { ISelectionContext } from './ISelectionContext'

export default class LegSelectionContext implements ISelectionContext {
  constructor(
    public legNumber: number,
    public buttonSelectionType: ButtonSelectionType
  ) {}
}
